import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { HeadContent, Outlet, createRootRouteWithContext } from '@tanstack/react-router'

import { TooltipProvider } from '@/components/ui/tooltip'
import { AuthContextProps } from '@/providers/auth-provider'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
  auth: AuthContextProps
}>()({
  component: () => (
    <TooltipProvider delayDuration={300}>
      <HeadContent />
      <Outlet />
      <ReactQueryDevtools />
    </TooltipProvider>
  ),
  head: () => ({
    meta: [
      {
        content: 'Applicant Tracking System',
        name: 'description',
      },
      {
        title: import.meta.env.VITE_APP_TITLE ?? 'ATS',
      },
    ],
  }),
})
